import { api } from './client';

export const getProducts = (params?: Record<string, string>) =>
  api.get('/products', { params }).then(r => r.data.data);

export const getProduct = (id: string) =>
  api.get(`/products/${id}`).then(r => r.data.data);

export const getCategories = () =>
  api.get('/products/categories').then(r => r.data.data);

// Admin
export const adminGetProducts = () =>
  api.get('/admin/products').then(r => r.data.data);

export const adminCreateProduct = (data: unknown) =>
  api.post('/admin/products', data).then(r => r.data.data);

export const adminUpdateProduct = (id: string, data: unknown) =>
  api.put(`/admin/products/${id}`, data).then(r => r.data.data);

export const adminDeleteProduct = (id: string) =>
  api.delete(`/admin/products/${id}`).then(r => r.data.data);

export const adminGetImageUploadUrl = (filename: string, contentType: string) =>
  api.post('/admin/products/image', { filename, contentType }).then(r => r.data.data);

export const adminGetCategories = () =>
  api.get('/admin/products/categories').then(r => r.data.data);

export const adminCreateCategory = (data: unknown) =>
  api.post('/admin/products/categories', data).then(r => r.data.data);
